export default "/biometrie-afghanistan/media/443aa9c45400f1c31b08350ce935fb93~original-screen.png";